import React, { PureComponent } from 'react';
import shortid from 'shortid';
import ArticleManager from '../managers/ArticleManager';

class Article extends PureComponent {
  constructor(props) {
    super();
    this.article = new ArticleManager(props.project_id);
  }

  getParagraphs() {
    return (
      <div>
        {this.article.getParagraphs().map(paragraph => (
          <p className="font-paragraph article__paragraph" key={`p-${shortid.generate()}`}>
            {paragraph}
          </p>
        ))}
      </div>
    );
  }

  getBulletsTitle() {
    return (
      <div className="font-title-semi_bold article__bullets_title">
        {`${this.article.getTitle()} ${this.article.getBulletsTitle()}`}
      </div>
    );
  }

  getOrderedBullets() {
    return (
      <ol>
        {this.article.getBullets().map(bullet => (
          <li key={`li-${shortid.generate()}`} className="font-paragraph article__ol__item">
            {bullet}
          </li>
        ))}
      </ol>
    );
  }

  getBullets() {
    return (
      <ul>
        {this.article.getBullets().map(bullet => (
          <li key={`li-${shortid.generate()}`}>
            <div className="article__bullet_icon" />
            <span className="font-paragraph">{bullet}</span>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    return (
      <div className="article">
        <div className="article--margin">
          <div className="font-title-semi_bold article__title">{this.article.getTitle()}</div>
          <div className="font-title article__subtitle">{this.article.getSubtitle()}</div>
          {this.getParagraphs()}
          {this.article.hasBullets() && this.getBulletsTitle()}
          {this.article.hasBullets()
            && (this.article.isOrdered() ? this.getOrderedBullets() : this.getBullets())}
        </div>
      </div>
    );
  }
}

export default Article;



// WEBPACK FOOTER //
// ./src/components/Article.js